/** TanStack Query keys shared by web and mobile, so realtime events update both the same way. */
export const qk = {
  me: ["me"] as const,
  org: ["org"] as const,
  members: ["org", "members"] as const,
  invitations: ["org", "invitations"] as const,
  clients: ["clients"] as const,
  projects: ["projects"] as const,
  project: (id: string) => ["project", id] as const,
  itemsAll: (projectId: string) => ["items", projectId] as const,
  items: (projectId: string, filter: { q?: string; status?: string; spaceId?: string } = {}) =>
    ["items", projectId, filter] as const,
  item: (id: string) => ["item", id] as const,
  admin: {
    orgs: ["admin", "orgs"] as const,
    users: (q: string) => ["admin", "users", q] as const,
    usage: (month: string) => ["admin", "usage", month] as const,
  },
};
